/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SicCodes
 */
export interface SicCodes {
}

/**
 * Check if a given object implements the SicCodes interface.
 */
export function instanceOfSicCodes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SicCodesFromJSON(json: any): SicCodes {
    return SicCodesFromJSONTyped(json, false);
}

export function SicCodesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SicCodes {
    return json;
}

export function SicCodesToJSON(value?: SicCodes | null): any {
    return value;
}

